export const perOMN = {
  O: 'Open Cover',
  M: 'Master Policy',
  N: 'None'
}

export const prtIL = {
  I: 'Immediate',
  L: 'Later'
}

export const premHdg = {
  P: 'Premium',
  A: 'As Arranged',
  R: 'Each Risk',
  M: 'Minimum',
  3: 'Takaful'
}

export const BenefitType = {
  L: 'Loading',
  D: 'Discount',
  P: 'Premium'
}

export const schemeType = {
  P: 'Personal',
  C: 'Commercial'
}
